import Head from 'next/head'

export const ListingStructuredData = ({ data }: { data: string }) => {
  if (!data) {
    return null
  }

  return (
    <Head>
      <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: data }} />
    </Head>
  )
}
